// MAKE SURE TO APPEND SLASH AFTER EVERY URL.
// URLs break on safari if there is no trailing slash.

export default {
  authentication: {
    refreshToken: "/solis/v1/auth/refresh-token/"
  },

  store: {
    courses: {
      list: "/catalogue/courses/",

      getFilters: "/catalogue/courses/get/filters/",

      details: courseSlug => `/catalogue/courses/${courseSlug}/`,
      milestones: courseSlug => `/catalogue/courses/${courseSlug}/contents/`,
      reviews: courseSlug => `/feedbacks/list/courseReview/${courseSlug}/`
    },

    packages: {
      list: "/catalogue/packages/",

      getFilters: packageSlug => `/catalogue/packages/${packageSlug}/`,

      details: packageSlug => `/catalogue/packages/${packageSlug}/`,
      items: packageSlug => `/catalogue/packages/${packageSlug}/contents/`
    },

    qualifications: {
      list: "/catalogue/qualifications/",

      getFilters: "/catalogue/qualifications/get/filters/",

      details: qualificationSlug =>
        `/catalogue/qualifications/${qualificationSlug}/`,
      items: qualificationSlug =>
        `/catalogue/qualifications/${qualificationSlug}/courses/`,
      reviews: qualificationSlug =>
        `/feedbacks/list/qualificationReview/${qualificationSlug}/`
    },

    certifications: {
      list: "/catalogue/certifications/",

      getFilters: "/catalogue/certifications/get/filters/",

      details: certificationSlug =>
        `/catalogue/certifications/${certificationSlug}/`,
      items: certificationSlug =>
        `/catalogue/certifications/${certificationSlug}/courses/`,
      reviews: certificationSlug =>
        `/feedbacks/list/certificationReview/${certificationSlug}/`
    }
  },

  cart: {
    addItem: "/catalogue/cart/item/"
  }
}
